import { useContext, type ReactNode } from 'react';
import type { IBaseAction } from '@models/actions/IBaseAction';
import Button from '@srm/ui/button';
import { MenuContext } from '@srm/ui/menu-context';
import { getActionLabel, getActionPerformer } from '@utils/actionPresentation';
import ActionParticipant from './ActionParticipant';

interface IActionParticipantMenuItemProps {
    action: IBaseAction;
    onRun: (action: IBaseAction) => void;
    context?: string;
    disabled?: boolean;
    children?: ReactNode;
}

const ActionParticipantMenuItem = ({ action, onRun, context, disabled, children }: IActionParticipantMenuItemProps) => {
    const { onClose } = useContext(MenuContext);
    const performer = getActionPerformer(action);
    if (!performer) return null;

    return (
        <ActionParticipant
            performer={performer}
            context={
                context ??
                (getActionLabel(action, true) !== getActionLabel(action) ? getActionLabel(action) : undefined)
            }
        >
            <Button
                variant="outline-neutral"
                size="sm"
                wrap
                disabled={disabled}
                aria-label={`${getActionLabel(action)}: ${performer.name}`}
                title={action.displayName}
                onClick={() => {
                    onClose?.();
                    onRun(action);
                }}
            >
                {getActionLabel(action, true)}
            </Button>
            {children}
        </ActionParticipant>
    );
};

export default ActionParticipantMenuItem;
